import { DealerChangeLogDtoToEntity } from "src/app/features/DealerChangeLog/services/mappers/DealerChangeLogDtoToEntity";
import type { DealerChangeLogDto } from "src/app/features/DealerChangeLog/types/DealerChangeLogDto";
import type { DealerChangeLogEntity } from "src/app/features/DealerChangeLog/types/DealerChangeLogEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const DealerChangeLogTableDtoMapper = (
    input: Readonly<ResourcePageDto<DealerChangeLogDto>>,
): ResourcePageEntity<DealerChangeLogEntity> => {
    return {
        list: input.list ? input.list.map(DealerChangeLogDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
